const PRODUCTION_API_PATH = '/v1';

/**
 * Use same-origin relative API paths on the server (IP or domain).
 * Keep full localhost URLs for local development.
 */
export default function resolveApiUrl() {
    const configured = process.env.REACT_APP_API_URL;

    if (typeof window !== 'undefined') {
        const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
        if (!isLocal && (!configured || /^https?:\/\//i.test(configured))) {
            return PRODUCTION_API_PATH;
        }
    }

    return configured || PRODUCTION_API_PATH;
}
